import React , { useState, useEffect }  from 'react';
import Grid from '@material-ui/core/Grid';
import SaveIcon from '@material-ui/icons/Save';
import CloseIcon from '@material-ui/icons/Close';
import {Formik, Form} from 'formik';
import * as Yup from 'yup';
import BiztranControls from "../../biztran_controls/BiztranControls";
import BiztranControlsFormik from "../../biztran_controls_formik/BiztranControlsFormik";
import UseFetchData from "../../../hooks/UseFetchData";

const CreateCurrency = (props) => {
    const [Currency,setCurrency] = useState('');
    const [CurrencySymbol,setCurrencySymbol] = useState('');
    const [ConversionRate,setConversionRate] = useState('');
    const [response, fetchData] = UseFetchData();
    const [responseGetData, fetchGetData] = UseFetchData();

    const validationSchema = Yup.object({
        Currency:Yup.string().required('Required!'),
        CurrencySymbol:Yup.string().required('Required!'),
        ConversionRate:Yup.number().required('Required!'),
    });

    const onSubmit = values => {
        var bodyFormData = new FormData();
        bodyFormData.append("Type", 'Currency');
        bodyFormData.append("PKID", props.PKID);
        bodyFormData.append("Value1", values.Currency);
        bodyFormData.append("Value2", values.CurrencySymbol);
        bodyFormData.append("Value3", values.ConversionRate);
        fetchData("Primary/Save", bodyFormData);
    };

    const getByIDData = () => {
        var bodyFormData = new FormData();
        bodyFormData.append("Type", 'Currency');
        bodyFormData.append("PKID", props.PKID);
        fetchGetData("Primary/GetByID", bodyFormData);
    }

    useEffect(() => {
        if(response.Response === true){
            props.setOpen(false);
            props.PopulateData();
            alert('Saved Succesfully.')
        }
        else if(response.Response === false){
            alert('Save Failed.')
        }
    },[response])

    useEffect(() => {
        if(responseGetData.length > 0){
            setCurrency(responseGetData[0].Currency);
            setCurrencySymbol(responseGetData[0].CurrencySymbol);
            setConversionRate(responseGetData[0].ConversionRate);
        }
    },[responseGetData])

    useEffect(() => {
        if(props.PKID !== ''){
            getByIDData();
        }
    },[])

    return(
        <div>
            <Formik initialValues={{Currency:Currency,CurrencySymbol:CurrencySymbol,ConversionRate:ConversionRate}} 
            validationSchema = {validationSchema} onSubmit = {onSubmit} enableReinitialize>
                {formik => {
                    return <Form>
                        <Grid spacing={2} container>
                            <Grid item xs={12}>
                                <BiztranControlsFormik 
                                    control='input' 
                                    type='text' 
                                    label='Currency'
                                    name='Currency' 
                                    onChange={(e) => setCurrency(e.target.value)}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <BiztranControlsFormik 
                                    control='input' 
                                    type='text' 
                                    label='Currency Symbol'
                                    name='CurrencySymbol' 
                                    onChange={(e) => setCurrencySymbol(e.target.value)}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <BiztranControlsFormik 
                                    control='input' 
                                    type='text' 
                                    label='Conversion Rate'
                                    name='ConversionRate' 
                                    onChange={(e) => setConversionRate(e.target.value)}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <div style={{width:'100%'}}>
                                    <div style={{display:'flex',justifyContent:'center',alignContent:"center"}}>
                                        <BiztranControls.Button
                                            text="SAVE"
                                            type="submit"
                                            startIcon={<SaveIcon/>}
                                        />
                                        <BiztranControls.Button
                                            text="CLOSE"
                                            startIcon={<CloseIcon />}
                                            onClick={() => {props.setOpen(false);}}
                                        />
                                    </div>
                                </div>
                            </Grid>
                        </Grid>
                    </Form>
                }}
            </Formik>
        </div>
    );
}

export default CreateCurrency;
